import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import { getPrices } from "../api";
import { Info, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function ServiceCharges() {
  const [prices, setPrices] = useState([]);
  useEffect(() => { getPrices().then(setPrices).catch(() => {}); }, []);

  return (
    <Layout>
      <SEO title="Elica Service Charges in Pune | Revive Solutions" description="Transparent starting prices for Elica chimney cleaning, hob, cooktop, oven, microwave and dishwasher service in Pune. Spare parts extra with your approval." canonical="/service-charges" />
      <section className="bg-[#0b1220] text-white py-14">
        <div className="max-w-4xl mx-auto px-6">
          <div className="chip chip-dark mb-4">Pricing</div>
          <h1 className="font-display text-4xl md:text-5xl font-medium leading-tight mb-3">Service Charges</h1>
          <p className="text-white/70 max-w-2xl">Our starting prices are transparent and consistent across all Pune PIN codes we serve. Spare part cost, if any, is shared and approved before we begin.</p>
        </div>
      </section>
      <section className="py-14 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="bg-white rounded-lg border border-neutral-200 overflow-hidden">
            <table className="table-clean w-full">
              <thead><tr><th>Service</th><th className="text-right">Starting Price</th></tr></thead>
              <tbody>{prices.map((p) => (<tr key={p.id}><td className="font-medium">{p.label}</td><td className="text-right font-semibold">{p.starting_price}</td></tr>))}</tbody>
            </table>
          </div>
          <div className="mt-5 flex items-start gap-2 text-sm text-slate-500"><Info className="w-4 h-4 mt-0.5 flex-shrink-0" /><p>Spare parts, if required, are charged separately after customer approval. GST applicable as per government rate. Charges may vary slightly for complex or non-standard installations, which will be communicated before work begins.</p></div>
          <div className="mt-8"><Link to="/book-service" className="btn-primary">Book a Service <ArrowRight className="w-4 h-4" /></Link></div>
        </div>
      </section>
    </Layout>
  );
}
